import { render, staticRenderFns } from "./withdrawalBenefit.vue?vue&type=template&id=a8aa017c&scoped=true&"
import script from "./withdrawalBenefit.vue?vue&type=script&lang=js&"
export * from "./withdrawalBenefit.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalBenefit.vue?vue&type=style&index=0&id=a8aa017c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa017c",
  null
  
)

export default component.exports